import React, { useState, useEffect } from "react";
import Card from "./CardItem"; // your existing Card component

const TabbedCardList = ({ cards = [], theme, noImage = false }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);

  // Hook to detect mobile screen size
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const handleScroll = (e) => {
    if (!isMobile) return;

    const container = e.target;
    const slideWidth = container.scrollWidth / cards.length;
    const newSlide = Math.round(container.scrollLeft / slideWidth);
    setCurrentSlide(newSlide);
    setActiveIndex(newSlide);
  };

  const scrollToSlide = (index) => {
    const container = document.querySelector(".mobile-card-carousel");
    if (container) {
      const slideWidth = container.scrollWidth / cards.length;
      container.scrollTo({
        left: slideWidth * index,
        behavior: "smooth",
      });
      setCurrentSlide(index);
      setActiveIndex(index);
    }
  };

  if (!cards || cards.length === 0) return null;

  return (
    <div className="w-full">
      {/* Tab Bar - Always Visible */}
      {/* <div className="flex flex-nowrap border-gray-300 mb-4 space-x-2">
        {cards.map((card, index) => (
          <button
            key={card.id || index}
            onClick={() => {
              setActiveIndex(index);
              if (isMobile) {
                scrollToSlide(index);
              }
            }}
            className={`flex-shrink-0 py-2 px-4 text-sm font-semibold border-b-2 transition-all duration-200 ${
              index === activeIndex
                ? "border-[var(--color-secondary)] text-[var(--color-secondary)]"
                : "border-transparent text-gray-200 hover:text-gray-100"
            }`}
          >
            {card.tabName || card.headline}
          </button>
        ))}
      </div> */}

      {/* Desktop: Active Card Content */}
      {!isMobile && (
        <Card
          {...cards[activeIndex]}
          image={cards[activeIndex].image}
          badge={cards[activeIndex].badge}
          tabbed
          theme={theme}
          noImage={noImage}
        />
      )}

      {/* Mobile: Slideable Cards */}
      {isMobile && (
        <>
          <div
            className="mobile-card-carousel flex overflow-x-auto snap-x snap-mandatory scrollbar-hide gap-4 pb-4"
            onScroll={handleScroll}
            style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
          >
            {cards.map((card, index) => (
              <div
                key={card.id || index}
                className="flex-shrink-0 w-full snap-center"
              >
                <Card
                  {...card}
                  image={card.image}
                  badge={card.badge}
                  tabbed
                  theme={theme}
                  noImage={noImage}
                />
              </div>
            ))}
          </div>

          {/* Mobile: Dots Indicator */}
          <div className="flex justify-center mt-6 space-x-2">
            {cards.map((_, index) => (
              <button
                key={index}
                onClick={() => scrollToSlide(index)}
                className={`w-3 h-3 rounded-full transition-colors duration-200 ${
                  index === currentSlide
                    ? "bg-gray-800"
                    : "bg-gray-300 hover:bg-gray-400"
                }`}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default TabbedCardList;
